import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import ContentPesquisa from '../../layout/content/ContentPesquisa';

import TemaService from '../../../service/TemaService';

import AcaoEnum from '../../../helper/enumerador/AcaoEnum';
import FormCodeEnum from '../../../helper/enumerador/FormCodeEnum';

class Tema extends AbstractComponent { 
    constructor(props) {
        super(props);        

        this.state = {            
            head : [
                {nome: 'Descrição', campo: 'descricao'},                
            ],
            
            callBack: {
                id: 1,

                body: [],

                pagination: [],

                recordCount: 0,

                indice: -1,

                mensagem: {
                    message: '',
                    code: 0
                },

                acao: AcaoEnum.NOTHING
            }
        }        
    }        
    
    onRemover(id, i) {    
        TemaService.remover(id).then(resposta => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = {
                message: 'Tema excluído com sucesso',
                code: FormCodeEnum.DEFAULT
            };
            callBack.acao = AcaoEnum.REMOVER;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        }).catch(erro => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = this.trataErro(erro);
            callBack.acao = AcaoEnum.ERRO;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        })
    }

    onLoad() {        
        TemaService.listar().then(resposta => {            
            let callBack = this.state.callBack;

            callBack.id++;
            callBack.body = resposta.data;
            callBack.mensagem = {
                message: '',
                code: 0
            };
            callBack.acao = AcaoEnum.LOAD;            
            callBack.indice = -1;

            this.setState({ callBack: callBack });            
        }).catch(erro => {
            let callBack = this.state.callBack;
            
            callBack.mensagem = this.trataErro(erro);
            callBack.indice = -1;
            callBack.acao = AcaoEnum.ERRO;

            this.setState({ callBack: callBack });
        })
    }

    render() {
        return (            
            <ContentPesquisa 
                title="Configurações do Tema"
                history=""
                
                modalErroMsg={this.state.modalErroMsg}

                head={this.state.head}                     
                
                cadastro={true}
                editar={true}
                link={'configuracao/tema'} 
                preload={this.props.preload}                   
                                    
                onLoad={() => this.onLoad()}
                onRemover={(id, i) => this.onRemover(id, i)}
                callBack={this.state.callBack}     
                
                route={(route) => this.props.route(route)}    
            />
        )
    }
}

export default Tema;